import { AxiosPromise } from "axios";
import {
  MemberDto,
  MembersResourceApi,
  UpdateMemberDto,
} from "../generated/account-client";
import { accountApiConfig, ops } from "./config";

const api = new MembersResourceApi(accountApiConfig);

const AccountMembersApi = {
  updateMember(memberId: string, dto: UpdateMemberDto): AxiosPromise<void> {
    return api.updateMember(memberId, dto, ops());
  },
  updateLocationsForMember(
    memberId: string,
    locations: Array<string>
  ): AxiosPromise<MemberDto> {
    return api.updateLocationsForMember(memberId, locations, ops());
  },
};

export default AccountMembersApi;
